/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Input, OnChanges, SimpleChanges, Output } from '@angular/core';
import { SysqueNumberBoxVM } from '../../models/sysque-number-box-vm';

@Component({
  selector: 'sysque-number-box-options-line',
  templateUrl: './sysque-number-box-options-line.component.html',
  styleUrls: ['./sysque-number-box-options-line.component.scss'],
  standalone: false
})
export class SysqueNumberBoxOptionsLineComponent implements OnChanges {
  @Input() label: string;
  @Input() numberBoxItems: SysqueNumberBoxVM[];
  @Input() showSpinButtons: boolean;
  @Output() valueChanged: EventEmitter<{ value: number; label: string }> = new EventEmitter<{
    value: number;
    label: string;
  }>();

  public items = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['numberBoxItems'] && this.numberBoxItems) {
      this.items = this.numberBoxItems.map(value => {
        let unit: string;
        
        if (value.isAngle) {
          unit = '0#°';
        } else if (value.isMetric) {
          unit = '0#.#####mm';
        } else if (value.isInFeet) {
          unit = '0#.##### (feet.)';
        } else {
          unit = '0#.#####"';
        }

        return {
          label: value.label,
          value: value.value,
          isAngle: value.isAngle || false,
          isMetric: value.isMetric || false,
          unit: unit,
          height: value.height,
          width: value.width,
          disabled: value.disabled,
          minValue: value.minValue
        };
      });
    }
  }

  public onValueChanged($event: number, label: string): void {
    this.valueChanged.emit({ value: $event, label: label });
  }
}
